export interface IUser {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

export class MUser {
  props: IUser;

  constructor(props: IUser) {
    this.props = props;
  }

  get fullName() {
    if (this.props.lastName.trim().length === 0) {
      return this.props.firstName;
    }
    return `${this.props.firstName} ${this.props.lastName}`;
  }
}
